import {jsonMember, jsonObject} from 'typedjson';
import {DataBase, TUPLA_TYPE} from './data-base';
import {PARAM_TYPE} from '../MessageContent/single-parameter';
import {DataTupla} from './data-tupla';
import {Tupla} from '../DoraWidget/dora-row/data/tupla';

@jsonObject
export class DataTuplaDescription extends DataBase {
  @jsonMember
  private name: string;
  @jsonMember
  private type: string;
  @jsonMember
  private chartDisabled: boolean;

  // Work attributes
  // tslint:disable-next-line:variable-name
  private _selected = false;

  // tslint:disable-next-line:variable-name
  private _visible = true;
  // tslint:disable-next-line:variable-name
  private _tooltipVisible = false;

  // Getter & Setter
  get tooltipVisible(): boolean {
    return this._tooltipVisible;
  }

  set tooltipVisible(value: boolean) {
    this._tooltipVisible = value;
  }

  get selected(): boolean {
    return this._selected;
  }
  set selected(value: boolean) {
      this._selected = value;
  }

  get visible(): boolean {
    return this._visible;
  }

  set visible(value: boolean) {
    this._visible = value;
  }

  public switchSelected(): void {
    this.selected = !this.selected;
  }
  public get Type(): TUPLA_TYPE {
    return TUPLA_TYPE[this.type];
  }
  public get Name(): string {
    return this.name;
  }
  public set Name(value: string) {
    this.name = value;
  }
  public get ChartDisabled(): boolean {
    return this.chartDisabled;
  }

  /**
   * Create Tupla from TuplaDescription
   */
  public createTupla(): Tupla {
    const tupla: Tupla = new Tupla();
    tupla.key = this.Id;
    return tupla;
  }

  // tslint:disable-next-line:member-ordering
  public static createFromTupla(tupla: DataTupla): DataTuplaDescription {
    let dataTuplaDescription: DataTuplaDescription;
    dataTuplaDescription = new DataTuplaDescription();

    dataTuplaDescription.Id = tupla.Id;
    dataTuplaDescription.Name = tupla.Id;
    dataTuplaDescription.type = tupla.Type.toString();
    dataTuplaDescription.visible = true;
    dataTuplaDescription.Language = 'en';
    dataTuplaDescription.chartDisabled = false;

    return dataTuplaDescription;
  }
}
